import VideoSticky from '@scripts/video-sticky/classes/VideoSticky.js';

window.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.video-sticky').forEach(video => {
        new VideoSticky(video);
    });
});
